import Cookie from 'js-cookie';

import { requestService } from 'shared/utils/services/requestService';

export const fetchCurrentUser = () => {
  return requestService({
    url: '/web-api/v1/users/me',
    method: 'get',
  }).catch((error) => {
    if (error?.response?.status === 401) {
      Cookie.remove('jwt');
    }
    throw error;
  });
};
